import React, { FC } from 'react';

import Header from 'components/Layout/Header';
import Footer from 'components/Layout/Footer';

import CookieConsent from 'components/Layout/CookieConsent';

import 'focus-visible';
import 'sanitize.css';
import './styles.scss';
import styles from './layout.module.scss';

interface IProps {
  appearance?: 'plain';
}

const Layout: FC<IProps> = ({
  appearance,
  children,
}) => (
  <>
    <main className={styles.container}>
      {(appearance !== 'plain') && <Header />}
      {children}
      {(appearance !== 'plain') && <Footer />}
    </main>
    <CookieConsent />
  </>
);

export default Layout;
